var kind = require("enyo/kind");

require("enyo-ui");

/**
 * [HoverSupport]{@link enyo-ui.HoverSupport} monitors `onenter` and
 * `onleave` events to detect when a control is hovered or not.
 *
 * @mixin enyo-ui.HoverSupport
 * @public
 */
module.exports = {

    /**
     * @private
     */
    name: "enyo-ui.HoverSupport",

    /**
     * Whether the control is hovered.
     *
     * @type     {boolean}
     * @memberof enyo-ui.HoverSupport
     * @private
     */
    hover: false,

    /**
     * @private
     */
    handlers: {
        onenter: "onEnter",
        onleave: "onLeave"
    },

    /**
     * Updates hover flag and notifies observers as needed.
     *
     * @memberof enyo-ui.HoverSupport
     * @method
     * @private
     */
    onEnter: kind.inherit(function(sup) {
        return function() {
            if (this.hover !== true) {
                this.set("hover", true);
            }

            return sup.apply(this, arguments);
        };
    }),

    /**
     * Updates hover flag and notifies observers as needed.
     *
     * @memberof enyo-ui.HoverSupport
     * @method
     * @private
     */
    onLeave: kind.inherit(function(sup) {
        return function() {
            if (this.hover !== false) {
                this.set("hover", false);
            }

            return sup.apply(this, arguments);
        };
    }),

    /**
     * Returns if this control has a mouse pointer hovering over it.
     *
     * @return   {boolean}  True if control has hover, False otherwise.
     * @memberof enyo-ui.HoverSupport
     * @public
     */
    isHovered: function() {
        return this.hover;
    },

    /**
     * Unhover when node gets removed from DOM. The browser might fire a
     * `leave` event, but this is not clearly documented in the HTML spec so
     * we trigger the [onLeave]{@link enyo-ui.HoverSupport#onLeave}
     * handler ourselves. The handler implements a guard such that it should not
     * execute if the control is not currently hovered.
     *
     * @memberof enyo-ui.HoverSupport
     * @method
     * @private
     */
    removeNodeFromDom: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);

            if (this.isHovered()) {
                this.onLeave();
            }
        };
    }),

    /**
     * Unhover when control is no longer generated (implying it does not have a
     * DOM Node anymore).
     *
     * @memberof enyo-ui.HoverSupport
     * @method
     * @private
     */
    generatedChanged: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);

            if (!this.generated && this.isHovered()) {
                this.onLeave();
            }
        };
    })

};
